import { render, staticRenderFns } from "./FeesForStopMasterPage.vue?vue&type=template&id=f1e3a464&scoped=true&"
import script from "./FeesForStopMasterPage.vue?vue&type=script&lang=js&"
export * from "./FeesForStopMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForStopMasterPage.vue?vue&type=style&index=0&id=f1e3a464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e3a464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1e3a464')) {
      api.createRecord('f1e3a464', component.options)
    } else {
      api.reload('f1e3a464', component.options)
    }
    module.hot.accept("./FeesForStopMasterPage.vue?vue&type=template&id=f1e3a464&scoped=true&", function () {
      api.rerender('f1e3a464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/feeMaster/feesForStopMaster/FeesForStopMasterPage.vue"
export default component.exports